/* Dandy Porch Club theme — global helpers.
   The homepage ZIP gate and lookbook logic are inlined in sections/home.liquid. */
(function () {
  // Smooth-scroll to in-page anchors when arriving with a hash (e.g. /#pricing)
  if (window.location.hash) {
    var id = window.location.hash.slice(1);
    window.addEventListener('load', function () {
      var el = document.getElementById(id);
      if (el) setTimeout(function () { el.scrollIntoView({ behavior: 'smooth' }); }, 120);
    });
  }
})();
